import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { AppApiEndpoints } from '../../app.api.endpoints';
import { HelperProvider } from './helper';
var ApiProvider = /** @class */ (function () {
    function ApiProvider(http, helper) {
        this.http = http;
        this.helper = helper;
        this.nodes = AppApiEndpoints.nodes;
        this.apiBaseUrl = environment.API_URL;
    }
    ApiProvider.prototype.request = function (_a) {
        var url = _a.url, method = _a.method, node = _a.node, data = _a.data, options = _a.options, urlParams = _a.urlParams;
        var requestUrl;
        var requestMethod;
        var headers = new HttpHeaders().set('Content-Type', 'application/json');
        if (url && method) {
            if (url.startsWith('http')) {
                requestUrl = url;
            }
            else {
                requestUrl = this.apiBaseUrl + url;
            }
            requestMethod = method;
        }
        else if (node) {
            if (typeof this.nodes[node] !== 'undefined') {
                var count = (this.nodes[node].url.match(/:/g) || []).length;
                if (count) {
                    if (Object.keys(urlParams).length !== count) {
                        var errors = [];
                        errors.push('Url parameters does not match required params.');
                        return Observable.throw(errors);
                    }
                    var urlFields = this.nodes[node].url.split('/');
                    for (var paramKey in this.nodes[node].params) {
                        urlFields[paramKey] = urlParams[this.nodes[node].params[paramKey]];
                    }
                    requestUrl = this.apiBaseUrl;
                    for (var _i = 0, urlFields_1 = urlFields; _i < urlFields_1.length; _i++) {
                        var urlField = urlFields_1[_i];
                        requestUrl += urlField + '/';
                    }
                    if (requestUrl.substr(requestUrl.length - 1) === '/') {
                        requestUrl = requestUrl.substr(0, requestUrl.length - 1);
                    }
                }
                else {
                    requestUrl = this.apiBaseUrl + this.nodes[node].url;
                }
                requestMethod = this.nodes[node].method;
            }
        }
        var defaultRequestOptions = {
            url: requestUrl,
            headers: headers,
        };
        var httpData = data || {};
        var requestOptions = options || defaultRequestOptions;
        if (requestMethod === 'GET') {
            return this.get(requestUrl, httpData, requestOptions);
        }
        else if (requestMethod === 'POST') {
            return this.post(requestUrl, httpData, requestOptions);
        }
    };
    ApiProvider.prototype.get = function (url, data, options) {
        options.params = data;
        return this.http.get(url, options)
            .map(this.extractData)
            .catch(this.handleError);
    };
    ApiProvider.prototype.post = function (url, data, options) {
        return this.http.post(url, data, options)
            .map(this.extractData)
            .catch(this.handleError);
    };
    ApiProvider.prototype.extractData = function (response) {
        console.log('ApiProvider::extractData()', 'response', response);
        return response.data || response || {};
    };
    ApiProvider.prototype.handleError = function (errorResponse) {
        var errors = [];
        if (errorResponse instanceof HttpErrorResponse) {
            var errorsBody = errorResponse.error.errors || [];
            for (var _i = 0, errorsBody_1 = errorsBody; _i < errorsBody_1.length; _i++) {
                var singleError = errorsBody_1[_i];
                errors.push(singleError.code);
            }
        }
        else {
            if (errorResponse.message) {
                errors.push(errorResponse.message);
            }
            else {
                errors.push(errorResponse.toString());
            }
        }
        return Observable.throw(errors);
    };
    return ApiProvider;
}());
export { ApiProvider };



// WEBPACK FOOTER //
// ./src/app/core/providers/api.ts.pre-build-optimizer.js